import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=182495e9&scoped=true"
import script from "./FileOptions.vue?vue&type=script&lang=js"
export * from "./FileOptions.vue?vue&type=script&lang=js"
import style0 from "./FileOptions.vue?vue&type=style&index=0&id=182495e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182495e9",
  null
  
)

export default component.exports